module.exports = __webpack_public_path__ + "img/third-onboarding-decoration-2.de30e0b9.svg";